import { PaymentRequestCreatePayoutResult, useCreatePendingRequestsPayouts } from 'api';
import { useTranslation } from 'i18n';
import { useMemo } from 'react';
import { Alert, Box, Button, Typography } from 'ui';

import { OutputDataGridWithDownload } from '../OutputDataGridWithDownload/OutputDataGridWithDownload';

export const CreatePayouts = () => {
  const { t } = useTranslation('orders');
  const { mutate, isPending: processing, data, error, isSuccess } = useCreatePendingRequestsPayouts();

  const outputGridData = useMemo(() => {
    if (!data?.results?.length) {
      return null;
    }
    const responseHeader = Object.keys(data.results[0]);
    return {
      columns: responseHeader.map((field) => ({
        field,
        flex: 1,
        headerName: field,
      })),
      rows: data.results,
    };
  }, [data]);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6">{t('financing.createPayouts.title')}</Typography>

      {error ? <Alert severity="error">{error.message}</Alert> : null}
      {isSuccess ? (
        <Alert severity="success">{t('financing.createPayouts.notifications.finishedProcessing')}</Alert>
      ) : null}

      {outputGridData ? (
        <Box sx={{ my: 2 }}>
          <OutputDataGridWithDownload<PaymentRequestCreatePayoutResult>
            rows={outputGridData.rows}
            columns={outputGridData.columns}
            rowIdGetter={(row) => `${row.buyer_id}`}
            filenamePrefix={'payouts-creation-submission-result'}
          />
        </Box>
      ) : null}
      <Box sx={{ mt: 2 }}>
        <Button onClick={() => mutate()} loading={processing}>
          {t('financing.createPayouts.actions.createPayouts')}
        </Button>
      </Box>
    </Box>
  );
};
